<template>
	<div>
		<b-modal v-model="showLabel" ok-title="Close" ok-only>
			<div class="text-center">
				<a :href="labelUrl" target="_blank" download="label.pdf">Download File</a>
			</div>
		</b-modal>
		<vue-headful
				:title="title">
		</vue-headful>
		<vue-element-loading :active="show"></vue-element-loading>
		<new-yb-line-item
				:action="this.newLineItemAction.NEW"
				v-if="createNewLineItemModal"
				v-model="createNewLineItemModal"
				:ndc-number="ndcNumber"
				:container-id="record.fieldData['Container ID']"
				:initial-pack-quantity="1"
        :initial-schedule="this.schedule"
				@created="onLineItemCreated"
				@canceled="closeNewLineItemModal"
		></new-yb-line-item>
		<new-yb-line-item
				:action="this.newLineItemAction.DUP"
				v-if="createNewLineItemWithDuplicateModal"
				v-model="createNewLineItemWithDuplicateModal"
				:ndc-number="ndcNumber"
				:initial-source="record.fieldData['Source']"
				:initial-source-number="record.fieldData['Source Number']"
				:initial-cause="record.fieldData['Cause']"
				:initial-lot-number="record.fieldData['Lot Number']"
				:container-id="record.fieldData['Container ID']"
				:initial-pack-quantity="null"
        :initial-schedule="record.fieldData['NDC Schedule']"
				@created="onLineItemCreated"
				@canceled="closeNewLineItemModal"
		></new-yb-line-item>
		<b-modal v-model="showExportModal" ok-title="Close" ok-only>
			<div class="text-center">
				<a v-if="exportModalFileType === 'xlsx'" :href="exportModalUrl" target="_blank"
				   :download="exportModalFileName">Download File</a>
				<a v-else :href="exportModalUrl" target="_blank" :download="exportModalFileName">Download File</a>
			</div>
		</b-modal>
		<b-modal
				:ok-title="'Move'"
				:cancel-title="'Cancel'"
				v-model="showMoveModal"
				:ok-disabled="!selectedContainer"
				v-if="showMoveModal"
				@ok="moveLineItem"
				width="600"
		>
			<template #modal-title>
				<h5>Move Line Item</h5>
				<span class="small">Select A Destination Container</span>
			</template>
			<MoveYellowBucketList
					:job-id="record.fieldData['Job::__PKJobID']"
					:container-id="record.fieldData['Container ID']"
			></MoveYellowBucketList>
		</b-modal>
		<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showLockModal" v-if="showLockModal"
			   @ok="lockLineItem">
			<template #modal-title></template>
			Are you sure you want to lock this line item?
		</b-modal>
		<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showUnlockModal" v-if="showUnlockModal"
			   @ok="unlockLineItem">
			<template #modal-title></template>
			Are you sure you want to unlock this line item?
		</b-modal>
		<b-modal
				:ok-title="'Yes'"
				:cancel-title="'No'"
				v-model="showDeleteModal"
				v-if="showDeleteModal"

				@ok="deleteLineItem">
			<template #modal-title></template>
			Are you sure you want to delete this line item?
		</b-modal>
		<b-modal v-model="showAddModal" v-if="showAddModal"
			   @ok="addLineItem" :ok-disabled="!ndcNumber || ndcNumber.length === 0">
			<template #modal-title><h5>Add Line Item</h5></template>
			<span>Select an NDC Number</span>
			<NDCSelect2
          v-model="ndcNumber"
          @schedule="schedule = $event"
          :registration="record.fieldData['hcn.job.reg::Registration Number']"
      ></NDCSelect2>
		</b-modal>
		<b-modal
				v-model="showEditModal"
				:ok-disabled="!ndcDirty"
				v-if="showEditModal"

				@ok="editNdc"
				id="edit-modal-body"
		>
			<template #modal-title><h5>Edit NDC Number</h5></template>
			<span>Select an NDC Number</span>
			<NDCSelect2
					v-model="ndcNumber"
					v-on:ndc-select-value-list="updateValueList"
          :registration="record.fieldData['hcn.job.reg::Registration Number']"
			></NDCSelect2>
			<div v-show="ndcNumber.includes('**') && selectionChanged === true" class="row mt-3">
				<div class="col-6"><strong>Pack Size**</strong>
					<input class="job-field form-control" v-model="packSize" required/>
				</div>
				<div class="col-6"><strong>UoM</strong>
					<v-select
							v-if="uomVL"
							v-model="uom"
							:options="uomVL"
					></v-select>
					<input v-else class="job-field form-control" v-model="uom" required/>
				</div>
			</div>
		</b-modal>
		<FeedbackPanel v-show="showFeedbackPanel"></FeedbackPanel>
		<div class="card pb-3">
			<div class="card-body">
				<div class="card-title">
					<div class="row">
						<h5 v-if="!parentLocked && (accessPrivileges.includes('UNLOCK_LINE_ITEM') || accessPrivileges.includes('LOCK_LINE_ITEM'))"
							class="col-4">
							<a v-if="accessPrivileges.includes('UNLOCK_LINE_ITEM') && locked" href="#"
							   @click.prevent="confirmUnlockLineItem">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock"></font-awesome-icon>
							</a>
							<a v-else-if="accessPrivileges.includes('LOCK_LINE_ITEM')" href="#"
							   @click.prevent="confirmLockLineItem">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock-open"></font-awesome-icon>
							</a>
							<strong>Yellow Bucket Line Item {{ record.fieldData['Container Line Item ID'] }}</strong>
						</h5>
						<h5 v-else class="col-4">
							<a v-if="locked">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock"></font-awesome-icon>
							</a>
							<a v-else>
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock-open"></font-awesome-icon>
							</a>
							<strong>Yellow Bucket Line Item {{ record.fieldData['Container Line Item ID'] }}</strong>
						</h5>
						<h5 class="col-8">
							<div class="float-right"><strong>NDC Number {{ record.fieldData['NDC Number'] }}</strong></div>
						</h5>
					</div>
					<div class="row">
						<ul class="nav col-4 justify-content-start pl-3">
							<b-pagination
									@change="goToSibling"
									v-if="siblingCount > 0"
									v-model="currentPage"
									:total-rows="siblingCount"
									:per-page="1"
									:first-number="true"
									:last-number="true"
									size="sm"
							></b-pagination>
							<div class="pl-2 align-self-center">Record {{currentPage}} of {{siblingCount}}</div>
						</ul>
						<ul class="nav col-8 justify-content-end">
							<li v-show="accessPrivileges.includes('CREATE_LINE_ITEM') && !locked" class="nav-item mr-3">
								<a id="show-modal" href="" @click.prevent="showAddLineItemModal">New Line Item
									<font-awesome-icon class="ml-1" icon="plus-circle"></font-awesome-icon>
								</a>
							</li>
							<li v-show="accessPrivileges.includes('CREATE_LINE_ITEM') && !locked" class="nav-item mr-3">
								<a href="" @click.prevent="duplicateLineItem">Duplicate Line Item
									<font-awesome-icon class="ml-1" icon="copy"></font-awesome-icon>
								</a>
							</li>
							<li v-show="accessPrivileges.includes('MOVE_LINE_ITEM') && !locked" class="nav-item mr-3">
								<a href="" @click.prevent="showMoveLineItem">Move Line Item
									<font-awesome-icon class="ml-1" icon="dolly"></font-awesome-icon>
								</a>
							</li>
							<li v-show="accessPrivileges.includes('DELETE_LINE_ITEM') && !locked" class="nav-item mr-3">
								<a href="" @click.prevent="confirmDeleteLineItem">Delete Line Item
									<font-awesome-icon class="ml-1" icon="times-circle"></font-awesome-icon>
								</a>
							</li>
							<li class="nav-item">
								<a href="" @click.prevent="printLabel(record.fieldData['Container Line Item ID'], true)">Generate Label
									<font-awesome-icon class="ml-1" icon="tag"></font-awesome-icon>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="card mb-3">
							<div class="card-body">
								<div class="row">
									<div class="col-2">
										<strong>Company ID</strong>
										<div class="job-field">{{ record.fieldData['Company::Company_PK_ID'] }}</div>
									</div>
									<div class="col-2">
										<strong>Registration</strong>
										<div class="job-field">{{ record.fieldData['Registration::Registration Number'] }}</div>
									</div>
									<div class="col-2">
										<strong>Job Name</strong>
										<div class="job-field">{{ record.fieldData['Job::Job Name'] }}</div>
									</div>
									<div class="col-2">
										<strong>Job ID</strong>
										<div class="job-field">
											<router-link
													:to="{name: 'job-view', params: {id: grandparentRecordIdString}}">
												{{ record.fieldData['Job::__PKJobID'] }}
											</router-link>
										</div>
									</div>
									<div class="col-2">
										<strong>Container Name</strong>
										<div class="job-field">{{ record.fieldData['hcn.holding_cn::Container Name'] }}</div>
									</div>
									<div class="col-2	">
										<strong>Container ID</strong>
										<div class="job-field">
											<router-link
													:to="{name: 'yb-container-view', params: {id: parentRecordIdString}}">
												{{ record.fieldData['hcn.holding_cn::Container ID'] }}
											</router-link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div class="card">
							<div class="card-header pt-2 pb-2">
								NDC Info
							</div>
							<div class="card-body">
								<div class="row mb-1">
									<div class="col-12">
										<strong>NDC Number</strong>
										<a v-show="accessPrivileges.includes('CREATE_LINE_ITEM') && !locked" class="pl-2"
										   href="" @click.prevent="showEditLineItemModal">
											Edit
											<font-awesome-icon icon="edit"></font-awesome-icon>
										</a>
										<div class="job-field">{{ record.fieldData['NDC Number'] }}</div>
									</div>
								</div>
								<div class="row mb-1">
									<div class="col-12">
										<strong>NDC Description</strong>
										<div class="job-field">{{ record.fieldData['NDC Description'] }}</div>
									</div>
								</div>
								<div class="row mb-1">
									<div class="col-6">
										<strong>Strength</strong>
										<div class="job-field">
											{{ record.fieldData['hcn.holding_li_SHOWCN_danox_dic::Strength'] }}
										</div>
									</div>
									<div class="col-6">
										<strong>Schedule</strong>
										<div class="job-field">
											{{ record.fieldData['hcn.holding_li_SHOWCN_danox_dic::CSA Schedule LU'] }}
										</div>
									</div>
								</div>
								<div class="row mb-1">
									<div class="col-3">
										<strong>Pack Size</strong>
										<div class="job-field">
											{{
												record.fieldData['hcn.holding_li_SHOWCN_danox_dic::Package Size Converted LU']
											}}
										</div>
									</div>
									<div class="col-3">
										<strong>UoM</strong>
										<div class="job-field">
											{{ record.fieldData['hcn.holding_li_SHOWCN_danox_dic::Package Size UoM LU'] }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card mt-3">
							<div class="card-header pt-2 pb-2">
								Form Info
							</div>
							<div class="card-body">
								<div class="row mb-1">
									<div class="col-12">
										<div class="row mb-1">
											<div class="col-6">
												<strong>Form 222 #</strong>
												<div class="job-field">{{ record.fieldData['Form 222 Number'] }}</div>
											</div>
											<div class="col-6">
												<strong>CWF #</strong>
												<div class="job-field">{{ record.fieldData['CWF Form Number'] }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<router-view
							:record="record"
							:record-id="recordId"
							:locked="locked"
							:entity="restEntity"
							:key="recordId"
							@update-record="updateRecord"
							@set-edit-mode="setEditMode"
					></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import feedbackMixin from '../mixins/feedback'
import printLabelMixin from '../mixins/print-label'
import detailViewMixin from '../mixins/detail-view'
import newLineItemActionMixin from '../mixins/new-line-item-action'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import NDCSelect2 from "../components/NDCSelect2";
import Modal from "../components/Modal";
import MoveYellowBucketList from "./container/MoveYellowBucketList";
import {EventBus} from "@/event-bus";
import FeedbackPanel from "../components/FeedbackPanel";
import NewYbLineItem from "@/components/NewYBLineItem";
import MoveContainerList from "@/views/container/MoveContainerList";

Vue.use(VueAxios, axios);

export default {
	name: "YBLineItem",
	components: {MoveContainerList, NewYbLineItem, MoveYellowBucketList, Modal, NDCSelect2, FeedbackPanel},
	mixins: [feedbackMixin, detailViewMixin, printLabelMixin, newLineItemActionMixin],
	mounted: function () {
		EventBus.$on('container-selected', this.onContainerSelected)
		EventBus.$on('line-item-created', this.onLineItemCreated)
		EventBus.$on('line-item-edited', this.onLineItemEdited)
	},
	destroyed() {
		EventBus.$off('container-selected', this.onContainerSelected)
		EventBus.$off('line-item-created', this.onLineItemCreated)
		EventBus.$off('line-item-edited', this.onLineItemEdited)
	},
	computed: {
		ndcDirty: function (){
			return this.ndcNumber !== this.record.fieldData['NDC Number']
		},
		grandparentRecordIdString: function () {
			return this.record.fieldData['Job::Record_ID'] ? this.record.fieldData['Job::Record_ID'].toString() : '0'
		},
		parentRecordIdString: function () {
			return this.record.fieldData['hcn.holding_cn::Record_ID'] ? this.record.fieldData['hcn.holding_cn::Record_ID'].toString() : '0'
		},
		showFeedbackPanel: function () {
			return !this.showEditModal && !this.showAddModal && !this.showDeleteModal && this.$route.name !== 'yb-line-item-edit'
		},
		parentIdString: function () {
			return this.record.fieldData['hcn.holding_cn::Record_ID'] ? this.record.fieldData['hcn.holding_cn::Record_ID'].toString() : '0'
		},
		grandParentIdString: function () {
			return this.record.fieldData['Job::Record_ID'] ? this.record.fieldData['Job::Record_ID'].toString() : '0'
		},
		isBulk: function () {
			return this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].includes('**')
		},
		labelerCodeOrgMatches: function () {
			return this.record.fieldData['labelercodes_dictionary::ParentOrganization'] === this.parentOrganization
		},
		locked: function () {
			return this.record.fieldData && this.record.fieldData['Locked Container Line Item'] && this.record.fieldData['Locked Container Line Item'].toUpperCase() === 'YES' ||
				this.parentLocked

		},
		parentLocked: function () {
				return this.record.fieldData['hcn.holding_cn::Locked Container'] && this.record.fieldData['hcn.holding_cn::Locked Container'].toUpperCase() === 'YES' ||
				this.record.fieldData['Job::Locked Job'] && this.record.fieldData['Job::Locked Job'].toUpperCase() === 'YES';
		},
		title: function () {
			return this.record.fieldData['NDC Number']
		}
	},
	methods: {
		onContainerSelected: function (container) {
			this.selectedContainer = container.container_id
		},
		validateBulk: function () {
			let returnValue = true;
			if (this.ndcNumber.includes('**') && this.selectionChanged) {
				if (!this.packSize) {
					this.pushError({
						message: 'Pack Size is required',
						type: 'WARNING'
					});
					returnValue = false
				}
				if (!this.uom) {
					this.pushError({
						message: 'UoM is required',
						type: 'WARNING'
					});
					returnValue = false
				}
			}
			return returnValue
		},
    validateFields: function () {
      console.log("field data", this.record.fieldData)
      this.flashMessages = [];
      const ndaSchedule = this.record.fieldData['NDC Schedule'];
      console.log("ndaSchedule", this.ndaSchedule);

      const localUOM= this.uom || ""
      const restrictedSchedules = ["1", "1n", "2", "2n", "3", "3n", "4", "4n", "5", "5n", "lc", "nc"];
      const restrictedUoMs = ["u", "k", "d"];
      let returnValue = true;
      const isRestrictedSchedule = restrictedSchedules.includes(ndaSchedule.toLowerCase());
      let packSizeHasDecimal;
      if (this.packSize == null) {
        packSizeHasDecimal = false
      } else {
        packSizeHasDecimal = this.packSize.toString().indexOf(".") >= 0;
      }
      console.log("Schedule", this.selectedChemical.schedule)
      console.log("is a restricted schedule", restrictedSchedules.includes(this.selectedChemical.schedule.toLowerCase()))

      if (this.ndcNumber.includes('**') && this.selectionChanged) {
        if (!this.packSize) {
          this.flashMessages.push({
            message: 'Pack Size is required',
            type: 'WARNING'
          });
          returnValue = false
        }
        if (!localUOM) {
          this.flashMessages.push({
            message: 'UoM is required',
            type: 'WARNING'
          });
          if (this.flashMessages.length > 0) {
            returnValue = false
          }
        }
        if (/*this should be ordered quantity packsize * pack count*/this.packSize != null && this.packSize.length > 8) {
          this.flashMessages.push({
            message: 'Can\'t report more than 8 digits.',
            type: 'WARNING'
          });
          if (this.flashMessages.length > 0) {
            returnValue = false
          }
        }
        let noDecimalUoMs = ['U',
          'K',
          'D',
          'u',
          'k',
          'd'];
        console.log("packsize", this.packSize)
        if (isRestrictedSchedule && packSizeHasDecimal && noDecimalUoMs.includes(localUOM.toLowerCase()) ) {
          this.flashMessages.push({
            message: `Pack size cannot contain decimal when reporting dosage form.`,
            type: 'WARNING'
          });
          if (this.flashMessages.length > 0) {
            returnValue = false
          }
        }
        if ((localUOM.toLowerCase() === "ml" && packSizeHasDecimal && isRestrictedSchedule)) {
          this.flashMessages.push({
            message: 'Quantity Reporting In mL Cannot Be Entered With A Decimal.',
            type: 'WARNING'
          });
          if (this.flashMessages.length > 0) {
            returnValue = false
          }
        }
      }
      console.log("Fields being validated return value", returnValue)
      return returnValue
    },
		updateValueList: function (event) {
			this.uomVL = event.valueList;
			this.selectionChanged = event.selectionChanged
      this.selectedChemical = event.selectedChemical;
    },
		editNdc: function () {
			this.clearErrors();
			if (this.ndcNumber !== this.record.fieldData['NDC Number'] && this.validateBulk()) {
				let payload = {}

				payload.user = this.username
				payload.initial = {}
				payload.initial.ndc = this.record.fieldData['NDC Number']
				payload.initial.packSize = this.record.fieldData['Pack Size']
				payload.initial.packSizeUoM = this.record.fieldData['Pack Size UoM']

				let id = this.record.fieldData['id']
				payload.id = id
				payload.ndc = this.ndcNumber
				payload.packSize = this.packSize
				payload.packSizeUoM = this.uom
				payload.containerId = this.record.fieldData['Container ID']

				this.axios.patch(`/3ds/api/yb-line-item/edit/${id}`, payload)
					.then(value => {
						console.log(JSON.stringify(value))
						this.editRecord()
					})
					.catch(reason => {
						console.error(JSON.stringify(reason))
						this.showEditModal = false
					})
			} else {
				this.showEditModal = false
			}
		},
		_addLineItem: function (fieldData) {
			Vue.axios.post('/3ds/api/yb-line-item',
				{
					fieldData: fieldData
				},
				{
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
				.then(value => {
					console.log('Successfully added line item')
					console.log(JSON.stringify(value))
					let recordId = value.data.recordId;
					this.updateRecord(
						{
							recordId: recordId,
							editMode: true
						})

				})
				.catch(reason => {
					console.error('Failed to add line item')
					console.error(JSON.stringify(reason))
				})
		},
		showAddLineItemModal() {
			this.ndcNumber = ''
			this.showAddModal = true
		},
		showEditLineItemModal() {
			this.packSize = '';
			this.uom = '';
			this.ndcNumber = this.record.fieldData['NDC Number'];
			this.showEditModal = true
		},
		onLineItemCreated(event) {
			this.updateRecord(event)
		},
		onLineItemEdited() {
			this.editRecord()
		},
		closeNewLineItemModal() {
			this.createNewLineItemModal = false
			this.createNewLineItemWithDuplicateModal = false
		},
		addLineItem: function () {
			this.showAddModal = false
			this.createNewLineItemModal = true
		},
		duplicateLineItem() {
			this.createNewLineItemWithDuplicateModal = true
			this.ndcNumber = this.record.fieldData['NDC Number']},
		lockLineItem: function () {
			this.show = true;
			let vm = this;
			let recordId = this.recordId;
			this.axios.patch(`/3ds/api/yb-line-item/lock/${recordId}`)
				.then(value => {
					console.log('Successfully locked line item with record ID ' + recordId)
					console.log(JSON.stringify(value))
					this.getRecord(recordId)
						.then(value => {
							this.record = value.data.data[0]
						})
						.catch(reason => {
							console.error('An error occurred while retrieving a line item with record ID ' + recordId);
							console.error(JSON.stringify(reason));
						})
				})
				.catch(reason => {
					console.error('Failed to lock line item with record ID ' + recordId)
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showLockModal = false;
					vm.show = false
				})
		},
		unlockLineItem: function () {
			this.show = true;
			let vm = this;
			let recordId = this.recordId;
			this.axios.patch(`/3ds/api/yb-line-item/unlock/${recordId}`)
				.then(value => {
					console.log('Successfully unlocked line item with record ID ' + recordId)
					console.log(JSON.stringify(value))
					this.getRecord(recordId)
						.then(value => {
							this.record = value.data.data[0]
						})
						.catch(reason => {
							console.error('An error occurred while retrieving a line item with record ID ' + recordId);
							console.error(JSON.stringify(reason));
						})
				})
				.catch(reason => {
					console.error('Failed to unlock line item with record ID ' + recordId)
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showUnlockModal = false;
					vm.show = false
				})
		},
		confirmLockLineItem: function () {
			this.showLockModal = true
		},
		confirmUnlockLineItem: function () {
			if (!this.parentLocked) {
				this.showUnlockModal = true
			}
		},
		confirmDeleteLineItem: function () {
			this.showDeleteModal = true
		},
		showMoveLineItem: function () {
			this.selectedContainer = '';
			this.showMoveModal = true
		},
		deleteLineItem: function () {
			let vm = this;
			let parentRecordId = vm.record.fieldData['hcn.holding_cn::Record_ID'];
			this.deleteRecord(this.recordId)
				.then(value => {
					vm.showDeleteModal = false;
					vm.$router.push({name: 'yb-container-view', params: {id: parentRecordId.toString()}})
				})
				.catch(reason => {
					vm.showDeleteModal = false;
					vm.authCheck(reason)
				})
		},
		moveLineItem: function () {
			if (this.selectedContainer.length > 0) {
				console.log(`Preparing to move line item ${this.recordId} to container ${this.selectedContainer}`)
				this.axios.post(`/3ds/api/yb-line-item/move/${this.recordId}`, {
					container: this.selectedContainer
				})
					.then(value => {
						console.log(JSON.stringify(value))
						this.record = value.data.data[0]
						// this.record = value.data.response.data[0]
					})
					.catch(reason => {
						console.log('An error occurred while moving a line item');
						this.authCheck(reason)
					})
					.finally(() => {
						this.showMoveModal = false;
						this.show = false;
					})
			}
		},
		showAlert() {
			this.dismissCountDown = this.dismissSecs
		}
	},
	data() {
		return {
			dismissSecs: 5,
			dismissCountDown: 0,
			showLabel: false,
			labelUrl: '',
			restEntity: 'yb-line-item',
			restViewEntity: 'yb-line-item-view',
			ndcNumber: '',
			packSize: 1,
			uom: '',
			uomVL: [],
			show: false,
			selectionChanged: false,
			createNewLineItemModal: false,
			showNewLineItemModal: false,
			createNewLineItemWithDuplicateModal: false,
			showNewLineItemWithDuplicateModal: false,
			showAddModal: false,
			showEditModal: false,
			showDeleteModal: false,
			showLockModal: false,
			showUnlockModal: false,
			showMoveModal: false,
			selectedContainer: '',
			showExportModal: false,
			exportModalUrl: null,
			exportModalFileName: null,
			exportModalFileType: null,
			portals: [{
				name: 'siblingLineItems',
				limit: 1000
			}],
			siblingCount: 0,
			currentIndex: 0,
			currentPage: 1,
      selectedChemical: null,
      schedule: '',
		}
	}
}
</script>
<style scoped>
#edit-modal-body >>> .alert {
    font-size: smaller;
    padding: 0.25rem 1rem;
}
</style>